module.exports = __webpack_public_path__ + "media/packs/images/flags/MM-8745d7f69a6c09a5f276d572808dec6f.png";